/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import Layout from "../../../../components/layout/Layout";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

import { Helmet } from "react-helmet";
import PensionAmount from "./PensionAmount";
import { PensionTransactionHistory } from "./PensionTransactionHistory";
import Loader from "components/Loader";
import Pagination from "react-bootstrap/Pagination";
import { PayoutFilter } from "../holiday-pension-filters/PayoutFilter";
import { PensionPDFModal } from "./PensionPDFModal";
import { mobileScroll } from "common/FunctionUtils";
import { LOCALES } from "common/constants";

const Pension = () => {
  const { t } = useTranslation();
  const year = new Date().getUTCFullYear();
  const language = localStorage.getItem("i18nextLng");

  const [loading, setLoading] = useState(false);

  const [toolTipError, setToolTipError] = useState({
    invalidFromdate: false,
    toDateNotSelected: false,
    fromDateNotSelected: false,
    lessPayAmount: false,
  });
  const [date, setDate] = useState({
    from: "",
    to: "",
  });

  const [tFilterDate, setTFilterDate] = useState({
    from: "",
    to: "",
  });

  const [spinner, setSpinner] = useState({
    spinner: false,
    Year: year,
  });
  const [incomeData, setincomeData] = useState({
    values: {},
    statusCode: null,
    usingDates: false,
  });
  const [show, setShow] = useState({
    PDFModal: false,
    HISModal: false,
  });

  const pageCount = 10;
  const [totalCount, setTotalCount] = useState();
  const [activePagination, setactivePagination] = useState(1);
  const [pensionSavingsData, setPensionSavingsData] = useState([]);

  const [filteredMonth, setFilteredMonth] = useState();
  const [filteredYear, setFilteredYear] = useState();
  const [showAllHistory, setShowAllHistory] = useState(true);

  useEffect(() => {
    downloadData();
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setToolTipError({
        toDateNotSelected: false,
      });
    }, 6000);
  }, [toolTipError]);

  const downloadData = async () => {
    try {
      if (date.from && date.to && date.from <= date.to) {
        setSpinner({
          ...spinner,
          spinner: true,
        });
        const res = await axios.get(
          `/salary/holiday-pension?fromDate=${date.from}&toDate=${date.to}`
        );
        setincomeData({
          values: res.data.response,
          statusCode: res.status,
          usingDates: true,
        });
        setSpinner({
          ...spinner,
          spinner: false,
        });
      } else if (date.from && date.to && date.from > date.to) {
        setToolTipError({
          invalidFromdate: true,
        });
      } else if (!date.from && date.to) {
        setToolTipError({
          fromDateNotSelected: true,
        });
      } else if (!date.to && date.from) {
        setToolTipError({
          toDateNotSelected: true,
        });
      } else if (!date.from && !date.to) {
        setSpinner({
          ...spinner,
          spinner: true,
        });
        const res = await axios.get(`/salary/holiday-pension`);
        setincomeData({
          values: res.data.response,
          statusCode: res.status,
        });
        setSpinner({
          ...spinner,
          spinner: false,
        });
      }
    } catch (error) {
      setSpinner({
        ...spinner,
        spinner: false,
      });
    }
  };

  const handleDownloadPDF = () => {
    const element = document.getElementById("salary-modal");
    if (element) {
      html2canvas(element).then((canvas) => {
        const imgWidth = 210;
        const pageHeight = 290;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        let heightLeft = imgHeight;
        const doc = new jsPDF("p", "mm"); // eslint-disable-line new-cap
        let position = 0;
        const pageData = canvas.toDataURL("image/jpeg", 1.0);
        const imgData = encodeURIComponent(pageData);
        doc.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        doc.setLineWidth(5);
        doc.setDrawColor(255, 255, 255);
        doc.rect(0, 0, 210, 295);
        heightLeft -= pageHeight;

        while (heightLeft >= 0) {
          position = heightLeft - imgHeight;
          doc.addPage();
          doc.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
          doc.setLineWidth(5);
          doc.setDrawColor(255, 255, 255);
          doc.rect(0, 0, 210, 295);
          heightLeft -= pageHeight;
        }
        doc.save("pension-details.pdf");
      });
    }
    setShow({ PDFModal: false });
  };

  let items = [];
  let paginationNumber = totalCount / pageCount;

  for (let number = 1; number <= Math.round(paginationNumber); number++) {
    items.push(
      <Pagination.Item
        key={number}
        active={number === activePagination}
        onClick={() => {
          setactivePagination(number);
        }}
      >
        {number}
      </Pagination.Item>
    );
  }

  const getPensionSavingsData = async () => {
    setLoading(true);
    try {
      const URL = `/salary/getall-employee-pensionamount?PageNumber=${activePagination}&PageSize=${pageCount}`;
      const result = await axios.get(URL);
      if (result?.status === 200) {
        setLoading(false);
        setPensionSavingsData(result?.data?.response);
        setTotalCount(result?.data?.totalCount);
      }
    } catch (err) {
      setLoading(false);
      toast.error(err?.response?.data?.message);
    }
  };

  useEffect(() => {
    if (!tFilterDate?.from && !tFilterDate?.to) getPensionSavingsData();
  }, [activePagination, pageCount, tFilterDate]);

  const filterTransactionData = async () => {
    setLoading(true);
    try {
      const dateStringFrom = new Date(tFilterDate?.from)
        .toISOString()
        .split("T")[0];
      const dateStringTo = new Date(tFilterDate?.to)
        .toISOString()
        .split("T")[0];

      const URL = `/salary/getall-employee-pensionamount?PageNumber=${activePagination}&PageSize=${pageCount}&fromDate=${dateStringFrom}&toDate=${dateStringTo}`;
      const result = await axios.get(URL);
      if (result?.status === 200) {
        setLoading(false);
        setPensionSavingsData(result?.data?.response);
      }
    } catch (err) {
      setLoading(false);
      toast.error(err?.response?.data?.message);
    }
  };

  useEffect(() => {
    if (tFilterDate?.from && tFilterDate?.to) {
      filterTransactionData();
    }
  }, [tFilterDate.from, tFilterDate?.to]);

  // API Call for Pdf Modal Data
  const [getTransaction, setgetTransaction] = useState([]);
  const [pensionSavingAmount, setpensionSavingAmount] = useState(0);

  const getFilteredTransactionHistory = async () => {
    try {
      let URL;
      if (showAllHistory) {
        URL = "/salary/getall-employee-pensionamount?type=1";
      } else if (filteredYear && !filteredMonth) {
        URL = `/salary/getall-employee-pensionamount?year=${filteredYear}-01-01&type=1`;
      } else if (filteredYear && filteredMonth) {
        const firstDateOfMonth = new Date(filteredYear, filteredMonth - 1, 1);
        firstDateOfMonth.setDate(firstDateOfMonth.getDate() + 1);
        const formattedFirstDate = firstDateOfMonth.toISOString().split("T")[0];
        URL = `/salary/getall-employee-pensionamount?Month=${formattedFirstDate}&type=1`;
      }
      if (URL) {
        setLoading(true);
        const result = await axios.get(URL);
        if (result?.status === 200) {
          setLoading(false);
          setgetTransaction(result?.data?.response);
          const total = result?.data?.response.reduce(
            (sum, transaction) => sum + (transaction.pensionAmount || 0),
            0
          );
          setpensionSavingAmount(total);
        }
      }
    } catch (err) {
      setLoading(false);
      toast.error(err?.response?.data?.message);
    }
  };

  useEffect(() => {
    if (show.PDFModal) {
      getFilteredTransactionHistory();
    }
  }, [show.PDFModal, filteredYear, filteredMonth, showAllHistory]);

  useEffect(() => {
    mobileScroll();
  }, []);

  return (
    <Layout
      className="p-4 mt-5 create_invoices invoice-space2 pension-space scroll_remove"
      showSidebar
      bgcolor
    >
      <Helmet>
        {language === LOCALES.EN_US ? (
          <link
            rel="canonical"
            href="https://invozio.com/dashboard/economy/pension"
          />
        ) : (
          <link
            rel="canonical"
            href="https://invozio.com/instrumentbrada/ekonomi/pension"
          />
        )}
      </Helmet>
      {loading && <Loader />}

      <div className="page-content mt-4">
        <PayoutFilter
          toolTipError={toolTipError}
          t={t}
          setDate={setDate}
          downloadData={downloadData}
          isPension={true}
        />

        <PensionAmount
          spinner={spinner}
          date={date}
          incomeData={incomeData}
          setShow={setShow}
          t={t}
          toast={toast}
        />

        <PensionTransactionHistory
          t={t}
          pensionSavingsData={pensionSavingsData}
          activePagination={activePagination}
          pageCount={pageCount}
          tFilterDate={tFilterDate}
          setTFilterDate={setTFilterDate}
        />

        <div className="paginationInvoice">
          <Pagination style={{ flexWrap: "wrap" }}>{items}</Pagination>
          <br />
        </div>
      </div>

      <PensionPDFModal
        show={show}
        setShow={setShow}
        t={t}
        incomeData={incomeData}
        pensionSavingAmount={pensionSavingAmount}
        getTransaction={getTransaction}
        handleDownloadPDF={handleDownloadPDF}
        filteredMonth={filteredMonth}
        setFilteredMonth={setFilteredMonth}
        filteredYear={filteredYear}
        setFilteredYear={setFilteredYear}
        showAllHistory={showAllHistory}
        setShowAllHistory={setShowAllHistory}
      />
    </Layout>
  );
};

export default Pension;
